import PartiesList from "./PartiesList";

export default PartiesList;
